<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="姓名">
        <a-input
          type="text"
          style="width: 600px"
          v-model="form.name"
        ></a-input>
      </a-form-item>
      <a-form-item label="Logo">
        <UploadFile v-if="show_editor" @callback="uploaded" :mult="false" folder="seller" />
        <img style="height: 40px" v-if="form.logo" :src="this.API + form.logo" alt="">
      </a-form-item>
      <a-form-item label="照片">
        <UploadFile v-if="show_editor" @callback="uploaded2" :mult="false" folder="seller" />
        <img style="height: 40px" v-if="form.photo" :src="this.API + form.photo" alt="">
      </a-form-item>
      </a-form-item>
      <a-form-item label="简介">
        <a-textarea
          style="width: 600px"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          v-model="form.desc"
        />
      </a-form-item>
      <a-form-item label="城市">
        <a-input style="width: 600px" type="text" v-model="form.city"></a-input>
      </a-form-item>
      <a-form-item label="地址">
        <a-input style="width: 600px" type="text" v-model="form.addr"></a-input>
      </a-form-item>
      <a-form-item label="电话">
        <a-input style="width: 600px" type="text" v-model="form.tel"></a-input>
      </a-form-item>
      <a-form-item label="邮件">
        <a-input style="width: 600px" type="text" v-model="form.email"></a-input>
      </a-form-item>
      <a-form-item label="其他联系方式">
        <a-input style="width: 600px" type="text" v-model="form.other_contact"></a-input>
      </a-form-item>
      <a-form-item label="详细介绍">
        <Editor
          v-if="show_editor"
          @callback="updateEditor"
          :data="form.content"
          folder="seller"
        />
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="sub">修改贝商</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import UploadFile from "../../components/uploadFile";
import Editor from "../../components/editor";
import moment from 'moment';

export default {
  components: { UploadFile, Editor },
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      show_editor: false,
      form: {}
    };
  },
  async created () {
    const id = this.$route.query.id;
    const r = await this.$axios.get('/seller/getInfo?id=' + id);
    // console.log(r);
    if(r.status == 1){
      this.form = r.info;
      this.show_editor = true
    }
  },
  methods: {
    moment,
    async sub() {
      const that = this;
      const r = await that.$axios.post("/seller/update", this.form);

      if (r.status == 1) {
        this.$router.push("/seller/list");
      }
    },

    uploaded(file) {
      this.form.logo = file.file_path
    },

    uploaded2(file) {
      this.form.photo = file.file_path
    },
    
    updateEditor(data) {
      this.form.content = data;
    }
  },
};
</script>